<script>

export default {
  name: 'VirtualTourView',
  props: {
    viewSource: {
      type: String, 
      required: true 
    }
  }
}
</script>
<template>
  <div>
    <b-modal 
      id="modal-VirtualTourView" 
      title="View 360 degree"
      ok-only ok-variant="secondary" ok-title="Close"
      size="xl"
      >
      <div>
        <iframe 
          width='100%' 
          height='500' 
          :src="this.viewSource" 
          frameborder='0' 
          allowfullscreen allow='xr-spatial-tracking'>
        </iframe>
      </div>
    </b-modal>
  </div>
</template>